import { Record } from "immutable";
import { CreatePopulatedBlockResponse } from "models/interfaces/populated-blocks/create-populated-block-response";

const defaultValues: CreatePopulatedBlockResponse = {
    blockId: 0,
    notebookId: 0,
    pageId: 0,
    notebookName: "",
    pageName: "",
};

export class CreatePopulatedBlockResponseRecord
    extends Record(defaultValues)
    implements CreatePopulatedBlockResponse
{
    constructor(params?: Partial<CreatePopulatedBlockResponse>) {
        const values = Object.assign({}, defaultValues, params);
        super(values);
    }

    public with(
        values: Partial<CreatePopulatedBlockResponse>
    ): CreatePopulatedBlockResponseRecord {
        return new CreatePopulatedBlockResponseRecord(
            Object.assign(this.toJS(), values)
        );
    }

    public getFriendlyRoute(): string {
        const hasNotebookName = this.notebookName
            ? `Notebooks > ${this?.notebookName} > `
            : "";
        const hasPageName = this.pageName ? this.pageName : "";
        return `${hasNotebookName}${hasPageName}`;
    }
}
